import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { combineColumnPreferences } from '../../common/saveconfiguration/utils';

export const INITIAL_STATE = {
    columns: constants.columns,
    impactDetailedRows: [],
    loading: false,
    impactDetailedDataLoaded: false
};

const setLoading = fp.set('loading');
const setColumns = fp.set('columns');
const setImpactDetailedRows = fp.set('impactDetailedRows');
const setImpactDetailedDataLoaded = fp.set('impactDetailedDataLoaded');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.SET_IMPACT_DETAILED_COLUMNS: {
            return setColumns(
                combineColumnPreferences(INITIAL_STATE.columns, action.data),
                state
            );
        }
        case actions.SET_DEFAULT_CONFIG: {
            return {
                ...state,
                columns: action.columns && action.columns.length
                    ? combineColumnPreferences(INITIAL_STATE.columns, action.columns)
                    : INITIAL_STATE.columns
            };
        }
        case actions.SET_IMPACT_DETAILED_ROWS: {
            return setImpactDetailedRows(action.data, state);
        }
        case actions.SET_IMPACT_DETAILED_DATA_LOADED: {
            return setImpactDetailedDataLoaded(action.loaded, state);
        }
        case actions.SET_ALL_EXPANDED: {
            return {
                ...state,
                impactDetailedRows: state.impactDetailedRows.map(
                    e => (e.level < 2 ? { ...e, expanded: action.data } : { ...e })
                )
            };
        }
        case actions.TOGGLE_ROW_EXPANDED: {
            return {
                ...state,
                impactDetailedRows: state.impactDetailedRows.map(
                    row => (row.id === action.data
                        ? { ...row, expanded: !row.expanded }
                        : row)
                )
            };
        }
        default:
            return state;
    }
}
